import { useEffect } from 'react';

import { HEADER_ID, PageLayout } from '@/components/templates/PageLayout';
import { CmButton, CmStack } from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import { useTargetsDomHeight } from '@/hooks/Dom';
import { CamelOrderCouponItemsForm } from '@/pages/camel-order/coupons/create/components/Form';
import { useCamelOrderCouponItemForm } from '@/pages/camel-order/coupons/create/useCamelOrderCouponItemForm';
import { routes } from '@/router';

const COUPON_NEW_PAGE_ID = 'coupon-new-page';

const CamelOrderCouponItemsNewPage: React.FC = (): JSX.Element => {
  const { targetsHeight } = useTargetsDomHeight([
    HEADER_ID,
    COUPON_NEW_PAGE_ID,
  ]);

  const props = useCamelOrderCouponItemForm();
  const { error, initializeNewPageState, handleCreate } = props;

  const isDisabledSubmitButton = (() => {
    return [
      !error.name.isTouched,
      !error.couponCode.isTouched,
      !error.discount.isTouched,
      Object.values(error).some((error) => error.isError),
    ].some((isError) => isError);
  })();

  useEffect(() => {
    (async () => {
      await initializeNewPageState();
    })();
  }, []);

  return (
    <PageLayout title={routes.camelOrderCouponsNew.title}>
      <CmStack
        id={COUPON_NEW_PAGE_ID}
        direction="row"
        my="25px"
        justifyContent="space-between"
        alignItems="center"
      >
        <CmBackLink to="/camel-order/coupons">一覧へ戻る</CmBackLink>
        {/*
         // @ts-ignore TS2590 */}
        <CmButton isDisabled={isDisabledSubmitButton} onClick={handleCreate}>
          登録
        </CmButton>
      </CmStack>
      <CamelOrderCouponItemsForm
        page="new"
        height={`calc(100vh - ${targetsHeight}px - 80px)`}
        {...props}
      />
    </PageLayout>
  );
};

export default CamelOrderCouponItemsNewPage;
